import { useState } from 'react';
import { UseFormRegisterReturn, FieldError } from 'react-hook-form';

interface PapTextAreaProps {
  formBinding: UseFormRegisterReturn;
  fieldName: string;
  fieldLabel: string;
  required?: boolean;
  placeholder?: string;
  error?: FieldError;
}

const PapTextArea: React.FC<PapTextAreaProps> = ({ formBinding, fieldName, fieldLabel, required = false, placeholder, error }) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className="mb-5">
      <label className="form-label" htmlFor={fieldName}>
        {fieldLabel}{required && <span className="text-destructive ml-1">*</span>}
      </label>
      <div className={`relative rounded-xl transition-all duration-200 ${isFocused ? 'ring-2 ring-accent/20' : ''}`}>
        <textarea {...formBinding}
          rows={4}
          name={fieldName}
          id={fieldName}
          placeholder={placeholder === undefined ? fieldLabel : placeholder}
          className={`form-textarea ${error ? 'border-destructive focus:border-destructive focus:ring-destructive/20' : ''}`}
          onFocus={() => setIsFocused(true)}
          onBlur={(e) => {
            setIsFocused(false);
            formBinding.onBlur(e);
          }}
        ></textarea>
      </div>
      {error && (
        <p className="mt-1.5 text-sm text-destructive flex items-center gap-1">
          {error.message}
        </p>
      )}
    </div>
  );
};

export default PapTextArea;
